import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const AdoptedConstraintsFilter: ISourcingToolSearchFilter = {
  id: "adopted-constraints-id",
  type: "checkbox",
  field: "sidebar.react.search_sidebar.constraints_adopted",
  must: ConstrainedListFilterMust.MATCH_NONE,
  values: [],
  mustOptions: [ConstrainedListFilterMust.MATCH_ALL, ConstrainedListFilterMust.MATCH_NONE],
  updateFilterDialogIsVisible: false,
  searchTypes: [SearchType.SOURCING_TOOL_UK],
};
